import { useState, useContext } from 'preact/hooks';
import { createContext } from 'preact'
import { form } from 'api';
import { setErrors } from 'utils/error';
import { useForm } from 'react-hook-form';
import { useWidget } from './widget.context';
import Button from 'components/layout/button';
import defaultStyle from 'components/form/form.context.style.scss'
import { Text } from 'preact-i18n';
import clsx from 'clsx';
import { jsonColorConvertor } from 'utils/colorConvertor';
import {
  hiddenFieldsValues,
  setRefererAddress,
} from 'utils/form-static-value-generator'

const generateFormDefaultValues = (valuesByAliasField, fields) => {
  let defaultValues = {}
  fields.map(field => {
    defaultValues = {
      ...defaultValues,
      [field.slug]: ""
    }
  })
  return { ...defaultValues, ...valuesByAliasField }
}
const FormWidgetContext = createContext()

const FormWidgetProvider = ({ children, style }) => {
  const [currentStep, setStep] = useState(1)
  const { formData: {
    formFields,
    formSlug,
    submitButtonText,
    buttonBackground,
    submitTextColor,
    initialValues: valuesByAliasField
  }, closeWidget, widgetType } = useWidget();
  // Form hook
  const {
    register,
    handleSubmit,
    errors,
    formState,
    setError,
    setValue,
    control,
    watch,
  } = useForm({
    mode: 'onChange',
    defaultValues: { ...generateFormDefaultValues(valuesByAliasField, formFields) }
  })

  const setFormErrors = (formErrors) => {
    const fieldsWithError = Object.keys(formErrors)
    const firstFieldWithError = formFields.findIndex(field => field.slug === fieldsWithError[0])
    if (firstFieldWithError !== -1) {
      setStep(firstFieldWithError + 1)
    }
  }

  const onError = (error) => {
    setFormErrors(error)
  }

  const submitForm = async (data) => {
    const formData = { ...data, ...hiddenFieldsValues(), ...setRefererAddress() }
    try {
      const { data: theData, errors: formErrors } = await form().submit(formData, formSlug)
      if (theData.row) {
        closeWidget()
        return
      }
      setErrors(formErrors, setError)
      setFormErrors(formErrors.form_errors)
    } catch (error) {
      setErrors(error, setError)
      setFormErrors(error.form_errors)
    }
  }

  const nextStep = (e) => {
    e.preventDefault();
    setStep(currentStep + 1)
  }

  const delayedNextStep = (delayTime = 700) => {
    if (currentStep < formFields.length) {
      setTimeout(() => {
        setStep(currentStep + 1)
      }, delayTime);
    }
  }

  const showNextButton = () => {

    const currentStepField = formFields[currentStep - 1]
    const currentStepValue = watch(currentStepField.slug)
    if (currentStep < formFields.length) {
      if (!currentStepField.required) return true;
      return Boolean(
        ![null, undefined, "", []].includes(currentStepValue)
      )
    }
    return false
  }
  const lastStep = Boolean(currentStep === formFields.length)
  const SubmitText = submitButtonText || <Text id="form.submit" />
  const customizedStyle = {
    backgroundColor: jsonColorConvertor(buttonBackground),
    color: jsonColorConvertor(submitTextColor)
  }
  return (
    <FormWidgetContext.Provider
      value={{
        register,
        handleSubmit,
        errors,
        formState,
        setError,
        setValue,
        control,
        watch,
        currentStep,
        setStep,
        delayedNextStep
      }}
    >
      <form onSubmit={handleSubmit(submitForm, onError)} className={style.multiStepForm} id="formaloo-widget-form">
        <div className={style.fieldsWrapper}>
          {children}
        </div>
        <div className={clsx({
          [defaultStyle.buttonsWrapper]: true,
          [defaultStyle.lastStepButtonWrapper]: lastStep && Boolean(widgetType === 'drawer')
        })}>
          {/* next question */}
          {showNextButton() && <Button onClick={nextStep} classnames={defaultStyle.submit} style={customizedStyle}><Text id="form.next" /></Button>}
          {/* submit form */}
          {lastStep && <Button type="submit" disabled={formState.isSubmitting} classnames={clsx({
            [defaultStyle.submit]: true,
            [defaultStyle.drawerSubmit]: Boolean(widgetType === 'drawer')
          })}
            style={customizedStyle}
          >
            {formState.isSubmitting ? <Text id="form.submitting" /> : SubmitText}
          </Button>}
        </div>
      </form>
    </FormWidgetContext.Provider>
  )
}

const useFormWidget = () => {
  const context = useContext(FormWidgetContext)
  if (context === undefined) {
    throw new Error(
      `useFormWidget must be used within a FormWidgetProvider`,
    )
  }
  return context
}
export { FormWidgetContext, FormWidgetProvider, useFormWidget }
